import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { Router } from '@angular/router';
import { School } from '../school';
import { SchoolMemo } from '../school-memo';
import { CKEDITORCONFIG } from '../ckeditor-config';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-online-course-create',
  templateUrl: './online-course-create.component.html',
  styleUrls: ['./online-course-create.component.css']
})
export class OnlineCourseCreateComponent implements OnInit {

  editorConfig: any = CKEDITORCONFIG;

  schoolForm!: FormGroup;
  nameIsNull = false;
  public Editor = Editor;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private router: Router
  ) { }

  ngOnInit() {
    this.schoolForm = this.builder.group({
      name: "",
      comment: "",
      hasOnlineCourse: [true, Validators.required],
      onlineCourseDescription: null
    });
  }

  sendForm(){
    this.nameIsNull = false;
    if(this.schoolForm.value.name == ""){
      console.log("name is empty");
      this.nameIsNull = true;
      return;
    }

        // remove zero width space in the comment
        let comment = this.schoolForm.value.comment.replace(/\u200B/g,"");

    this.httpService.postSchool(
      new School(
        this.schoolForm.value.name,
        new SchoolMemo(comment),
        true,
        [],
        [],
        [],
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [],
        null
      )
    ).subscribe(() => {
      console.log("success");
      this.router.navigateByUrl("/management/online-courses");
    });
  }

}
